// extracted by mini-css-extract-plugin
module.exports = {"vanWindNaarWatt":"VanWindNaarWatt-module--van-wind-naar-watt--1PkDk"};